import React from "react";
import { Link } from "react-router-dom";

import logowhite from "../../assets/iglf-logo-white.png";
import { ReactComponent as FbLogo } from "../../assets/fb.svg";
import { ReactComponent as LinkedIn } from "../../assets/linkedin.svg";

const Footer = (props) => {

  const handleChoice = function (choice) {
    props.context.actions.toggleTab(choice)
  }

  return (
    <footer>
      <div className="footer-logo">
        <Link to="/">
          <img
            src={logowhite}
            alt="It's A Good Life Logo"
            width="280"
            height="100"
          />
        </Link>
        <div className="footer-logo-border"></div>
      </div>
      <div className="footer-container">
        <div className="footer-link-container">
          <div className="footer-links">
            <div className="footer-link-heading">
              <Link to="/services/">Services</Link>
            </div>
            <div className="footer-sublink">
              <Link to="/services/#wellness-assessment" onClick={(e) => handleChoice("wellness")}>Wellness Assessment</Link>
              <Link to="/services/#metabolic-testing" onClick={(e) => handleChoice("metabolic")}>Metabolic Testing</Link>
              <Link to="/services/#nutrition" onClick={(e) => handleChoice("nutrition")}>Nutrition</Link>
              <Link to="/services/#personal-training" onClick={(e) => handleChoice("personal")}>Personal Training</Link>
              <Link to="/services/#wellness-portal">Wellness Portal</Link>
            </div>
          </div>
          <div className="footer-links">
            <div className="footer-link-heading">
              <Link to="/about/">About</Link>
            </div>
            <div className="footer-sublink">
              <Link to="/about/">Meet Your Trainers</Link>
            </div>
            <div className="footer-sublink">
              <Link to="/faq/">FAQs</Link>
            </div>
          </div>
        </div>
        <div className="footer-link-container">
          <div className="footer-links">
            <div className="footer-link-heading">
              <Link to="/contact/">Contact</Link>
            </div>
            <div className="footer-sublink">
              <Link to="/contact/">Contact Form</Link>
            </div>
            <div className="footer-sublink">
              <a href="mailto:info@itsagoodlifefitness.com">info@itsagoodlifefitness.com</a>
            </div>
          </div>
          <div className="footer-links" id="packages-link-container">
            <div className="footer-link-heading">
              <Link to="/packages/">Packages</Link>
            </div>
            <div className="footer-sublink">
              <Link to="/packages/">Complete Packages</Link>
            </div>
            <div className="footer-sublink">
              <Link to="/individual/">Individual Sessions</Link>
            </div>
          </div>
        </div>
        <div className="footer-link-container" id="fb-container">
          <div className="footer-links">
            <div className="footer-link-heading">
              <a href="https://www.facebook.com/Itsagoodlifefitness" title="Facebook" target="_blank" rel="noopener noreferrer">Follow Us!</a>
            </div>
            <div className="social-sublink">
              <a href="https://www.facebook.com/Itsagoodlifefitness" title="Facebook" target="_blank" rel="noopener noreferrer">
                <FbLogo id="facebook" />
              </a>
              <a href="https://www.linkedin.com/company/itsagoodlifefitness" title="LinkedIn" target="_blank" rel="noopener noreferrer">
                <LinkedIn id="linkedin" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
